module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAARxJREFUSA29Vs0KgkAQdvUg0aVL1Dl6Ag8iC/VuvUtPUrCIgV46dKjORQ+QHsRmA2ETZ39moYGF0Zn9vvlmcNcgMFhVVTNDijYc6qJ5nu/quj4VRbHU5eliDAsKISZhGJ4hvuq67hpF0SZN0weWj71HFXDO37CJw7ozxtZt2x4pSlAFfUXQpgX4AhZJiZFAEvmQWBH4kKAzkKCqZVn2hOefmZRlOVdzxnxrArl5SNI0zcFEYt0itbrBTC5xHG+TJHmpOb1PIpCbbUnIBArJDfwpfIyjSpxmIEFdjUygtAitXhZDapEC/v26YcgcG7KzgiG4PAQxcGcFY+CmE9a6RRRwawVUcCsCH3AjgS+4luBfV+be5z6WCozm+9vyAVk+wQbCO8NwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/arrow.png
// module id = 268
// module chunks = 0 1 2 3 4 5 6 8